import {
  FormControl,
  Grid,
  InputLabel,
  SxProps,
  Theme,
  useTheme,
} from "@mui/material";
import {
  DatePicker,
  DatePickerSlotsComponentsProps,
} from "@mui/x-date-pickers";
import { useEffect, useState } from "react";

const getStyles = (theme: Theme): { [key: string]: SxProps } => ({
  label: {
    transform: "translate(0, -1rem) scale(1)",
    fontSize: 12,
  },
  fieldContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
});

const slotProps: DatePickerSlotsComponentsProps<Date> = {
  textField: {
    variant: "standard",
    size: "small",
    fullWidth: true,
  },
  actionBar: {
    actions: ["accept", "clear"],
  },
};

type DateRangeSelectProps = {
  label: string;
  value: { from: Date | null; to: Date | null };
  onChange: (from: Date | null, to: Date | null) => void;
};

export default function DateRangeSelect({
  label,
  value,
  onChange,
}: DateRangeSelectProps) {
  const styles = getStyles(useTheme());
  const [from, setFrom] = useState<Date | null>(null);
  const [to, setTo] = useState<Date | null>(null);

  useEffect(() => {
    if (!value.from) {
      setFrom(null);
    }
    if (!value.to) {
      setTo(null);
    }
  }, [value.from, value.to]);

  const handleFromChange = (newFrom: Date | null) => {
    setFrom(newFrom);
    onChange(newFrom, to);

    if (newFrom && to && newFrom > to) {
      handleToChange(newFrom);
    }
  };

  const handleToChange = (newTo: Date | null) => {
    setTo(newTo);
    onChange(from, newTo);

    if (newTo && from && from > newTo) {
      handleFromChange(newTo);
    }
  };

  return (
    <Grid item xs={12} sm={12}>
      <FormControl fullWidth sx={{ mt: 1.5 }}>
        <InputLabel shrink sx={styles.label}>
          {label}
        </InputLabel>
        <Grid container spacing={2}>
          <Grid item xs={6} sx={styles.fieldContainer}>
            <DatePicker
              value={from}
              label="From"
              onChange={handleFromChange}
              slotProps={slotProps}
            />
          </Grid>
          <Grid item xs={6} sx={styles.fieldContainer}>
            <DatePicker
              value={to}
              label="To"
              onChange={handleToChange}
              slotProps={slotProps}
            />
          </Grid>
        </Grid>
      </FormControl>
    </Grid>
  );
}
